// 出餐看板的重抓與本機改動協調（多台 iPad 同步）
//
// 單量多時推播會連續進來，每則都觸發一次 GET /order_status。原本各自 then(setOrderStatusList)，
// 晚發出但先回來、或早發出卻慢回來的舊結果會蓋掉新結果，各機台停在不同進度；
// 送出品項狀態的途中若剛好有重抓回來，也會把樂觀更新蓋回舊狀態。這裡統一處理：
// - 同時只跑一個請求，期間再要求重抓就合併成「跑完再抓一次」
// - 送出改動期間（或請求發出後有改動）回來的結果一律丟掉，改動全部結束後再抓一次
// - 頁籤（未完成／已出單）在請求途中切換，舊頁籤的結果丟掉
// - 本機改動依序送出，連點兩下不會兩個請求同時讀到同一個狀態
export const createBoardSync = ({ fetchList, applyList, getType }) => {
    let inFlight = false;
    let queued = false;
    let pendingMutations = 0;
    let generation = 0;
    let mutationChain = Promise.resolve();

    const refresh = async () => {
        if (inFlight) {
            queued = true;
            return;
        }
        inFlight = true;
        const type = getType();
        const startedGeneration = generation;
        let data = null;
        try {
            data = await fetchList(type);
        } catch (error) {
            data = null;
        }
        inFlight = false;

        const fresh = pendingMutations === 0 && startedGeneration === generation && type === getType();
        if (fresh && Array.isArray(data)) {
            applyList(data, type);
        } else if (!fresh && pendingMutations === 0) {
            queued = true;
        }

        if (queued && pendingMutations === 0) {
            queued = false;
            await refresh();
        }
    };

    // fn 回傳 Promise；改動依序執行，全部結束後重抓一次以伺服器為準
    const mutate = (fn) => {
        pendingMutations += 1;
        generation += 1;
        const run = mutationChain.then(() => fn());
        mutationChain = run.catch(() => {});
        return run.finally(() => {
            pendingMutations -= 1;
            generation += 1;
            if (pendingMutations === 0) refresh();
        });
    };

    return { refresh, mutate };
};
